import { styled } from '@mui/material';
import { globalClasses } from 'core/common/constants/global-classes';
import { Typography, LinearProgress } from 'core/common/ui/ui-kit';

export const ProgressContainerStyled = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  min-height: 24px;
  margin-right: auto;
  margin-left: auto;
`;

export const StepsContainerStyled = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & > ${globalClasses.MuiLinearProgressBarRoot}:not(:last-child) {
    margin-right: 8px;
  }
`;

export const LinearProgressStyled = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'isAnimated',
})<{ isAnimated: boolean }>`
  ${globalClasses.MuiLinearProgressBar} {
    transition: ${({ isAnimated }) => (isAnimated ? 'transform 0.5s linear' : 'none')};
  }
`;

export const TitleTypographyStyled = styled(Typography)`
  margin-bottom: 8px;
  text-align: center;
`;
